let baseUrl = 'https://gdsqyartapi.gdscc.cn/api'
let mUrl = 'https://mgdsqyart.gdscc.cn'

// let baseUrl = 'http://gdwhgapi.wanjuan.cn/api'
// var mUrl = 'http://gdwhgsp.wanjuan.cn'

let baseTitle = "广东群艺荟"


let shareUrl = `${mUrl}/#/`
let qrImg = `qr_test.png`

export default {
  baseUrl,
  baseTitle,
  mUrl,
  shareUrl,
  qrImg
};